import React, {Suspense} from 'react';

const Survey = React.lazy(() => import(/* webpackChunkName: "lazy-survey", webpackPrefetch: false */ './Survey'));

export default function SurveyHost() {
    return (
        <Suspense fallback={<div className="align-content-center align-self-center">Lädt...</div>}>
            <Survey/>
        </Suspense>
    );
}